import Link from 'next/link';

import { DefaultProps } from '../../../types/DefaultProps';

import styles from './ButtonText.module.scss';

import type { FC, ReactNode } from 'react';

import { assertNever } from '@/packages/nurse-senka-frontend-sdk';

export type ButtonProps = DefaultProps & {
  color: 'default' | 'white';
  children?: ReactNode;
  link?: string;
  useNextLink?: boolean;
  isTargetBlank?: boolean;
};

export const ButtonText: FC<ButtonProps> = ({
  children,
  color,
  link,
  useNextLink,
  isTargetBlank,
}) => {
  switch (color) {
    case 'default':
      if (useNextLink && link && isTargetBlank) {
        return (
          <Link
            href={link}
            prefetch={false}
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className={styles['button-text-blue']}>{children}</span>
          </Link>
        );
      }

      if (useNextLink && link) {
        return (
          <Link href={link} prefetch={false}>
            <span className={styles['button-text-blue']}>{children}</span>
          </Link>
        );
      }

      return <span className={styles['button-text-blue']}>{children}</span>;
    case 'white':
      if (useNextLink && link) {
        return (
          <a href={link}>
            <span className={styles['button-text-white']}>{children}</span>
          </a>
        );
      }

      return <span className={styles['button-text-white']}>{children}</span>;
    default:
      return assertNever(color);
  }
};
